<template>
  <div class="about">
    <div>
      <div class="position-relative jp-column">
        <el-image :src="mainBg" class="w-100 title-bg"></el-image>
        <h4 v-if="$i18n.locale !== 'en'" class="jp-en-title">Contact Us</h4>
        <h1 class="jp-title">{{$t('menu.contactUs')}}</h1>
      </div>
    </div>
    <section class="jp-column">
      <div class="about-message">
        <el-row :type="rowType" align="middle">
          <el-col :span="24">
            <el-form :rules="formRules" ref="formMessage" label-position="top" label-width="80px" :model="formMessage">
              <el-form-item :label="$t('about.message.name')" prop="nameSurname">
                <el-input v-model="formMessage.nameSurname"></el-input>
              </el-form-item>
              <el-form-item :label="$t('about.message.namePinyin')" prop="pinYin">
                <el-input v-model="formMessage.pinYin"></el-input>
              </el-form-item>
              <el-form-item :label="$t('about.message.companyName')" prop="address">
                <el-input v-model="formMessage.address"></el-input>
              </el-form-item>
              <el-form-item :label="$t('about.message.eMail')" prop="emailAddress">
                <el-input v-model="formMessage.emailAddress"></el-input>
              </el-form-item>
              <el-form-item :label="$t('about.message.telephone')" prop="telephone">
                <el-input v-model="formMessage.telephone"></el-input>
              </el-form-item>
              <el-form-item :label="$t('about.message.content')" prop="content">
                <el-input type="textarea" :autosize="{ minRows: 8 }" v-model="formMessage.content"></el-input>
              </el-form-item>
              <el-form-item>
                <p class="agree-content">
                  {{ $t('about.message.agreeContent') }} 
                </p>
                <p class="privacy-policy-content" @click="openPrivacyPolicy">
                  {{ $t('footer.privacyPolicy') }}
                </p>
              </el-form-item>
              <el-form-item prop="telephone" class="agree">
                <el-checkbox v-model="agreeChecked">{{ $t('about.message.agree') }}</el-checkbox>
              </el-form-item>
              <!-- <el-form-item :label="$t('about.message.securityCode')" prop="securityCode">
                <el-col :span="18" class="pl-0">
                  <el-input v-model="formMessage.securityCode"></el-input>
                </el-col>
                <el-col :span="6" class="pr-0">
                  <img class="w-100 jp-pointer message-security-code" :src="securityCodeData.imageContent" @click="refreshSecurityCode()" />
                </el-col>
              </el-form-item> -->
              <el-form-item>
                <el-button type="primary" @click="onSubmit" :disabled="!agreeChecked" :loading="loading">{{$t('about.message.submit')}}</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </section>
    <privacy-policy-modal :isOpen="dialogVisible" @modalClose="handleClose"></privacy-policy-modal>
  </div>
</template>

<script>
import { getSecurityCode, sendMessage } from '@/api/websiteApi';
import privacyPolicyModal from '@/components/privacy-policy-modal';

import mainBg from '@/assets/img/contract_bg.png';
import laboratory1 from '@/assets/img/laboratory1.jpg';
import laboratory2 from '@/assets/img/laboratory2.jpg';
import laboratory3 from '@/assets/img/laboratory3.jpg';
import laboratory4 from '@/assets/img/laboratory4.jpg';
import laboratory5 from '@/assets/img/laboratory5.jpg';
import laboratory6 from '@/assets/img/laboratory6.jpg';
import laboratory7 from '@/assets/img/laboratory7.jpg';
import laboratory8 from '@/assets/img/laboratory8.jpg';
import about1 from '@/assets/img/about1.jpg';
import about2 from '@/assets/img/about2.png';
import about3 from '@/assets/img/about3.jpg';
export default {
  name: 'about',
  data () {
    // let validatePhone = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error(this.$t('common.phoneNotEmpty')));
    //   } else if(!(/^1[34578]\d{9}$/.test(value))) {
    //     callback(new Error(this.$t('common.pleaseEnterPhone')))
    //   } else {
    //     callback();
    //   }
    // };
    return {
      mainBg: mainBg,
      activeName: 'first',
      agreeChecked: false,
      loading: false,
      dialogVisible: false,
      collapseActiveName: '',
      rowType: '',
      formMessage: {},
      securityCodeData: {},
      laboratory1: laboratory1,
      laboratory2: laboratory2,
      laboratory3: laboratory3,
      laboratory4: laboratory4,
      laboratory5: laboratory5,
      laboratory6: laboratory6,
      laboratory7: laboratory7,
      laboratory8: laboratory8,
      about1: about1,
      about2: about2,
      about3: about3,
      formRules: {
        nameSurname: [{ required: true, message: this.$t('common.pleaseEnterContent'), trigger: 'change' }],
        pinYin: [{ required: true, message: this.$t('common.pleaseEnterContent'), trigger: 'change' }],
        emailAddress: [{ required: true, message: this.$t('common.pleaseEnterContent'), trigger: 'change' }],
        address: [{ required: true, message: this.$t('common.pleaseEnterContent'), trigger: 'change' }],
        // telephone: [{ required: true, validator: validatePhone, trigger: 'change' }],
        content: [{ required: true, message: this.$t('common.pleaseEnterContent'), trigger: 'change' }],
        // securityCode: [{ required: true, message: this.$t('common.pleaseEnterSecurityCode'), trigger: 'change' }],
      }
    }
  },
  components: {
    privacyPolicyModal
  },
  created() {
    this.getWidth();
    this.refreshSecurityCode()  // 获取验证码
    this.$nextTick(() => {
      if (this.$route.params && this.$route.params.type === 'fifth') {
        this.activeName = this.$route.params.type;
        setTimeout(() => {
          this.$el.querySelector('#contractUs').scrollIntoView({ block: 'start', behavior: 'smooth' });
        }, 300)
      }
    })
  },
  methods: {
    getWidth() {
      let width = `${document.documentElement.clientWidth}`;
      if (width < 992) {
        this.rowType = ''
      } else {
        this.rowType = 'flex'
      }
    },
    refreshSecurityCode() {
      getSecurityCode().then(res => {
        res.imageContent = "data:image/png;base64," + res.imageContent;
        this.securityCodeData = res;
        this.formMessage.securityCode = res.codeText; 
      })
    },
    onSubmit() {
      this.loading = true;
      this.formMessage.securityId = this.securityCodeData.securityId;
      this.$refs['formMessage'].validate((valid) => {
        if (valid) {
          sendMessage(this.formMessage).then(res => {
            this.$message({
              message: this.$t('common.submitSuccess'),
              type: 'success'
            });
            this.formMessage = {};
            this.$refs['formMessage'].resetFields();
            this.loading = false;
          }).catch(error => {
            this.$message({
              message: this.$t('common.submitSuccess'),
              type: 'success'
            });
            // this.$message.error(this.$t('common.verificationCodeError'));
            this.loading = false;
          })
        } else {
          this.loading = false;
        }
      });
    },
    moreOrganizational() {
      this.$router.push({ name: 'organizational' });
    },
    openPrivacyPolicy() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/style/variables.scss';
.about {
  .first-section {
    position: relative;
    padding: 3rem 0 0 0;
    .el-row {
      height: 300px;
    }
    &.sub-first-section {
      .el-row {
        height: 380px;
      }
    }
  }
  .about-module {
    z-index: 101;
  }
  section {
    padding-top: 3rem;
    h2 {
      font-size: 2rem;
      margin-top: 0;
      margin-bottom: 2rem;
    }

    .about-introduce {
      font-size: 18px;
      margin: 0 auto;
      text-align: left;
      line-height: 3.3rem;
      p {
        width: 600px;
      }
      b {
        width: 96px;
        text-align: right;
      }
    }

    .about3-img {
      height: 300px;
      width: auto;
      margin: 0 auto;
    }

    .jp-project-content {
      font-size: 1.4rem;
    }

    .about-org {
      h4 {
        font-size: 1.3rem;
      }
      .org-content {
        text-align: left;
        font-size: 1rem;
        padding-left: 1rem;
      }
      .el-collapse-item__header {
        height: 80px;
      }
    }
    .about-contact {
      background-color: #fff;
      height: 240px;
      border-radius: 12px;
      margin-bottom: 3rem;
      img {
        height: 240px;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
      }
    }
    .about-message {
      background-color: #fff;
      width: 800px;
      margin: 0 auto;
      border-radius: 12px;
      margin-bottom: 3rem;
      padding-right: 1rem;
      font-weight: bold;
      img.message-img {
        // height: 600px;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
      }
      .message-gradient {
        background-image: linear-gradient(to bottom, rgba(10, 116, 194, 0.47), #0074ca);
        position: absolute;
        height: 600px;
        top: 0;
        width: 100%;
        border-radius: 12px;
        opacity: 0.95;
        mix-blend-mode: lighten;
      }
      .el-button {
        width: 70%;
        margin: 0 auto;
      }
      .message-security-code {
        height: 40px;
      }
      .agree-content, .agree {
        text-align: left;
      }
      .privacy-policy-content {
        cursor: pointer;
        text-align: left;
        color: #0a74c2;
      }
    }
  }
  .organizational {
    .el-col {
      margin-top: 0.5rem;
    }
  }
  .parent-dot {
    position: relative;
    right: 5px;
    .dot1 {
      position: absolute;
      width: 20px;
      height: 20px;
      opacity: 0.2;
      border-radius: 50%;
      background-color: #0a74c2;
    }.dot2 {
      position: absolute;
      top: 3px;
      left: 3px;
      width: 14px;
      height: 14px;
      opacity: 0.4;
      border-radius: 50%;
      background-color: #0a74c2;
    }.dot3 {
      position: absolute;
      top: 6px;
      left: 6px;
      width: 8px;
      height: 8px;
      opacity: 0.6;
      border-radius: 50%;
      background-color: #0a74c2;
    }
  }
  .parent-dot.hot {
    .dot1, .dot2, .dot3 {
      background-color: #e91e63;
    }
  }
}

@media (max-width: 768px){
  .about {
    section {
      .jp-project-content {
        font-size: 1.7rem;

        .el-image {
          max-height: 104px;
        }
      }
      .about-introduce {
        width: 100%;
        line-height: 3.5rem;
        font-size: 16px;
        margin-top: 1rem;
        b {
          width: 196px;
        }
      }
      .about-contact {
        img {
          border-radius: 12px;
        }
      }
      .about-message {
        height: auto;
        padding: 0;
        width: 100%;
        .el-button {
          width: 100%;
        }
        .message-security-code {
          height: 40px;
        }
      }
      .about3-img {
        height: 350px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/contactUs.vue